import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { BasicResponse } from './types';

export const getChangePassword = async ( lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/change-password?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<BasicResponse>;
	})
	.catch((error) => {
		console.error('Change password request error: ', error);
		throw error;
	});
};
